import { render, staticRenderFns } from "./InviteDetail.vue?vue&type=template&id=98c5d55e&scoped=true"
import script from "./InviteDetail.vue?vue&type=script&lang=js"
export * from "./InviteDetail.vue?vue&type=script&lang=js"
import style0 from "./InviteDetail.vue?vue&type=style&index=0&id=98c5d55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c5d55e",
  null
  
)

export default component.exports